import React from 'react';
import {IServiceFactory} from '../../../services/service-factory.interface';
import {OrbitContext} from '../../../orbit-context';
import {reaction as mobxReaction, IReactionDisposer, IReactionOptions, IReactionPublic} from 'mobx';

export class OrbitComponentWithState<TProps, TState> extends React.Component<TProps, TState> {

    private _reactions: IReactionDisposer[] = [];

    constructor(props, context?) {
        super(props, context);

        if(context)
            this.context = context;
    }

    protected get services(): IServiceFactory {
        if (this.props['context']) {
            return this.props['context'].services;
        }
        return this.context.services;
    }


    //React life time hooks stubs for future use
    componentDidMount() {}

    componentWillUnmount() {
        this._disposeReactions();
    }


    protected reaction<T>(expression: (r: IReactionPublic) => T, effect: (arg: T, r: IReactionPublic) => void, opts?: IReactionOptions): IReactionDisposer {
        let disposer = mobxReaction(expression, effect, opts);
        this._reactions.push(disposer);
        return disposer;
    }

    private _disposeReactions() {
        this._reactions.forEach(disposer => disposer());
    }
}

OrbitComponentWithState.contextType = OrbitContext;
